// src/utils/apiClient.js
import axios from 'axios';
import { encryptAES, decryptAES } from './cryptoUtils';
import { getApgJWT } from './getApgJWT'
import { refreshToken } from './refreshToken';


// Create a custom axios instance
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL, 
  // If you need withCredentials for cookies, set it here:
  withCredentials: true,
});
// REQUEST INTERCEPTOR
apiClient.interceptors.request.use(
  async (config) => {

    try{
      const token = await getApgJWT();
      console.log("token found")
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
    } catch (err) {
      console.error('Error fetching apg jwt token:', err);
    }

    if (config.method === 'post') {
      // Convert the data to JSON string
      const plainDataString = JSON.stringify(config.data);
      // console.log('plainDataString:', plainDataString)
      // Encrypt
      const encryptedPayload = encryptAES(plainDataString);
      // Replace the payload
      config.data = { encryptedRequest: encryptedPayload };
    }
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  // (error) => {
  //   return Promise.reject(error);
  // }
  async (error) => {
    const originalRequest = error.config;
    if (
        error.response?.status === 401 &&
        !originalRequest._retry
    ) {
        originalRequest._retry = true;
        try {
            const newToken = await refreshToken();
            originalRequest.headers.Authorization =
                `Bearer ${newToken}`;
            return apiClient(originalRequest);
        } catch (e) {
            localStorage.clear();
            window.location.href = "/";
        }
    }
    return Promise.reject(error);
  }
);
// RESPONSE INTERCEPTOR
apiClient.interceptors.response.use(
  (response) => {
    // If there's an 'encryptedResponse' field, decrypt it
    if (response.data && response.data.encryptedResponse) {
      try {
        const decryptedString = decryptAES(response.data.encryptedResponse);
        // console.log("decrypted", decryptedString)
        // parse to JS object
        const plainObject = JSON.parse(decryptedString);
        // console.log("decrypted", plainObject)

        // replace data in the response
        response.data = plainObject;
      } catch (err) {
        console.error('Decryption error:', err);
        // optionally handle error or pass it through
      }
    }
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);
export default apiClient;